export default "__VITE_ASSET__BRmofr7J__"